<div class="body">
    <div class="headline">
        {{headline}}
    </div>
    <div class="content-text">
        {{text}}
    </div>
    <div class="check-value">
        {{checkValue}}
    </div>
    <div class="control-row">
        <button mat-raised-button color="accent" (click)="reject()">
            Abbrechen
        </button>
        <button *ngIf="hasSecondButton" mat-raised-button color="primary" (click)="secondButtonClick()">
            {{secondButtonTitle}}
        </button>
    </div>
</div>